<template>
    <div class="modal-wrapper">
        <div class="modal" v-bind:class="{['modal-size-' + size]: size}">
            <div class="modal-inner">
                <div class="modal-inner-content">
                    <div class="width-100 relative modal-contents-wrap">
                        <slot></slot>
                    </div>
                    <div class="width-100 relative modal-actions-wrap">
                        <Button variant="neutral" @click.native="$emit('close')" class="float-left">Cancel</Button>
                        <slot name="modal-actions">

                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Button from '../../components/Button/Button';

    export default {
        name: 'Modal',
        components: {
            Button
        },
        props: {
            size: {
                type: String,
                default: 'auto'
            }
        },
        data () {
            return {

            }
        },
        computed: {

        },
        mounted () {

        },
        methods: {

        }
    }
</script>
<style src="./Modal.scss" scoped lang="scss"></style>

